import React from "react"
import Pie from "./pie"
import { ChartType, PIE_CHART } from "constants/charts"
import Legend from "components/Shared/Legend"
import { FormattedNumber } from "react-intl"
import "./index.scss"
import {
	psychographics,
	renderText,
} from "components/CustomerBehavior/CustomerProfiling/Shared/utils"

interface ChartProps {
	data: any[]
	colorPalette: string[]
	chartType: ChartType
	type: string
}

const LessThanOne = "< 1%"

const Chart: React.FC<ChartProps> = ({ chartType, ...props }) => {
	const { data, colorPalette, type } = props
	const isPsychographics = type === psychographics

	const charts = {
		[PIE_CHART]: <Pie {...props} />,
	}

	return (
		<React.Fragment>
			{charts[chartType]}
			<div className="chart-legend-container">
				{data.map((item: any, index) => (
					<Legend
						key={item.id}
						labels={[
							renderText(item.id),
							<FormattedNumber key={item.id} value={item.value} style="percent">
								{(value: string) => (
									<React.Fragment>
										{item.value * 100 > 1 ? value : LessThanOne}
									</React.Fragment>
								)}
							</FormattedNumber>,
						]}
						background={colorPalette[index % colorPalette.length]}
						psychographics={isPsychographics}
					/>
				))}
			</div>
		</React.Fragment>
	)
}

export default Chart
